const byId = (id) => (candidate) => (candidate ? candidate.id === id : false);

// noinspection JSUnusedGlobalSymbols
export default byId;
